module.exports = __webpack_public_path__ + "img/searchCEO.1baa0361.png";